<template>
  <div>
    <div class="row">
      <div class="col-10">
        <AccountsSummaryWidget :gridHeight="320" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="320">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/accounts/agedtrialbalance#tab-agedbalance">Aged Trial Balance Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/accounts/agedtrialbalance#tab-statements">Send Statements Tool</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/accounts/detailedsummary/glass">Invoice - Glass Summary Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/accounts/detailedsummary/services">Invoice - Services Summary Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/accounts/invoicevaluegroups">Invoice Value Summary Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <InvoiceBreakdownWidget :gridHeight="270" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <AccountsReceivableSummaryWidget :gridHeight="320" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-invoice-daily">
              <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily</div>
                <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-invoice-monthly">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Monthly</div>
                <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-payments-daily">
              <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily</div>
                <div class="tabbedbox-tab-subtitle">Payments Received Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-payments-monthly">
              <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Monthly</div>
                <div class="tabbedbox-tab-subtitle">Payments Received Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-invoice-daily" class="tabpage-padding-0">
              <InvoiceDailyChartWidget :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-invoice-monthly" class="tabpage-padding-0">
              <InvoiceMonthlyChartWidget :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-payments-daily" class="tabpage-padding-0">
              <PaymentsReceivedDailyChartWidget :gridHeight="540" :embedded="true" />
            </TabPage>
            <TabPage tabid="tab-payments-monthly" class="tabpage-padding-0">
              <PaymentsReceivedMonthlyChartWidget :gridHeight="540" :embedded="true" />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import AccountsSummaryWidget from '@/modules/intelligence/dashboardWidgets/accountsSummaryWidget'
import InvoiceBreakdownWidget from '@/modules/intelligence/dashboardWidgets/invoiceBreakdownWidget'
import InvoiceDailyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceDailyChartWidget'
import InvoiceMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceMonthlyChartWidget'
import PaymentsReceivedDailyChartWidget from '@/modules/intelligence/dashboardWidgets/paymentsReceivedDailyChartWidget'
import PaymentsReceivedMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/paymentsReceivedMonthlyChartWidget'
import AccountsReceivableSummaryWidget from '@/modules/intelligence/dashboardWidgets/accountsReceivableSummaryWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsAccountsDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    AccountsSummaryWidget,
    InvoiceBreakdownWidget,
    InvoiceDailyChartWidget,
    InvoiceMonthlyChartWidget,
    PaymentsReceivedDailyChartWidget,
    PaymentsReceivedMonthlyChartWidget,
    AccountsReceivableSummaryWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  data() {
    return {
      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
  },
  mounted() {
    
  },
  beforeDestroy() {
    
  },
  methods: {
    
  }
  
}
</script>